import * as React from 'react';
import { FormControl, Button, Well, Alert, Label } from 'react-bootstrap';
import MaskedInput from "react-maskedinput";
import MediaQuery from 'react-responsive';
import { FilterWrapper } from './styles';

interface IProps {
    onSearch: (firstName: string, lastName: string, alias: string, email: string, dateOfBirth: string) => void
}

interface IState {
    firstName: string,
    lastName: string,
    alias: string,
    email: string,
    dateOfBirth: string
}

const initialState: IState = {
    firstName: '',
    lastName: '',
    alias: '',
    email: '',
    dateOfBirth: ''
}

class Filters extends React.Component<IProps, IState> {
    readonly state = initialState;

    handleFieldChange = (field: string, value: string) => {
        let state = { ...this.state };
        state[field] = value;

        this.setState(state);
    }

    handleKeyDown = (event: React.KeyboardEvent<FormControl & HTMLInputElement>): void => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.handleSearch();
        }
    }

    handleSearch = () => {
        let { firstName, lastName, alias, email, dateOfBirth } = this.state;
        this.props.onSearch(firstName, lastName, alias, email, dateOfBirth);
    }

    handleClear = () => {
        this.setState(initialState);
    }

    render = () => {
        return (
            <>
                <FilterWrapper>
                    <h4 style={{ marginTop: 0, marginBottom: 15 }}>SEARCH FILTERS</h4>

                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 20, marginBottom: 20 }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                            <div className='text-right' style={{ marginRight: 5 }}><strong>First Name:</strong></div>
                            <div>
                                <FormControl
                                    style={{ width: 110 }}
                                    value={this.state.firstName}
                                    onKeyDown={this.handleKeyDown}
                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => this.handleFieldChange('firstName', e.currentTarget.value)}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                            <div className='text-right' style={{ marginRight: 5 }}><strong>Last Name:</strong></div>
                            <div>
                                <FormControl
                                    style={{ width: 110 }}
                                    value={this.state.lastName}
                                    onKeyDown={this.handleKeyDown}
                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => this.handleFieldChange('lastName', e.currentTarget.value)}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                            <div className='text-right' style={{ marginRight: 5 }}><strong>Alias:</strong></div>
                            <div>
                                <FormControl
                                    style={{ width: 110 }}
                                    value={this.state.alias}
                                    onKeyDown={this.handleKeyDown}
                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => this.handleFieldChange('alias', e.currentTarget.value)}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                            <div className='text-right' style={{ marginRight: 5 }}><strong>Email:</strong></div>
                            <div>
                                <FormControl
                                    name='email'
                                    style={{ width: 330 }}
                                    value={this.state.email}
                                    onKeyDown={this.handleKeyDown}
                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => this.handleFieldChange('email', e.currentTarget.value)}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                            <div className='text-right' style={{ marginRight: 5 }}><strong>DOB:</strong></div>
                            <div>
                                <MaskedInput
                                    name='birthDate'
                                    className='form-control'
                                    style={{ width: 105 }}
                                    mask={'11/11/1111'}
                                    value={this.state.dateOfBirth}
                                    onKeyDown={this.handleKeyDown}
                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => this.handleFieldChange('dateOfBirth', e.currentTarget.value)}
                                />
                            </div>
                        </div>

                        <MediaQuery minDeviceWidth={1878}>
                            <div style={{ width: 150, marginRight: 10 }}>
                                <Button className='btn-block' bsStyle="primary" onClick={this.handleSearch}>Search</Button>
                            </div>

                            <div style={{ width: 150 }}>
                                <Button className='btn-block' onClick={this.handleClear}>Clear Filters</Button>
                            </div>
                        </MediaQuery>

                        <MediaQuery maxDeviceWidth={1877}>
                            <div style={{ width: 150, marginRight: 10 }}>
                                <Button className='btn-block btn-sm' bsStyle="primary" onClick={this.handleSearch}>Search</Button>
                            </div>

                            <div style={{ width: 150 }}>
                                <Button className='btn-block btn-sm' onClick={this.handleClear}>Clear Filters</Button>
                            </div>
                        </MediaQuery>
                    </div>

                    <Label bsStyle='info' style={{ marginLeft: 20, fontSize: '90%' }}>
                        Note: The first name and last name will look for anything that begins with the text entered
                    </Label>
                </FilterWrapper>
            </>
        );
    }
}

export default Filters;